<template>
  <div
    class="unit-nav-container"
    :class="{ 'top-38': hasNotifications.length }"
  >
    <v-icon :class="activecourse[0].baseYear">ribbon</v-icon>
    <v-tooltip
      location="bottom"
      v-if="
        (getRoles && getRoles.includes('tester')) ||
        (getFeatures && getFeatures.includes('unit-pdf'))
      "
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          target="_blank"
          elevation="0"
          class="unit-icon mt-10 active"
          id="menu-unit-download-pdf"
          :class="activecourse[0].baseYear"
          :href="downloadPdfURL()"
        >
          <v-icon size="12">download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('unitStudy.pdfDownload.tooltip') }}</span>
    </v-tooltip>
    <div class="team-container" id="team-container">
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            class="unit-icon"
            id="menu-truth"
            @click.stop="scrollToTop('truth', 1)"
            :class="[activecourse[0].baseYear, { active: active_el == 1 }]"
          >
            <span>T</span>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.navigation.truth') }}</span>
      </v-tooltip>
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            id="menu-equip"
            class="unit-icon mt-3"
            :class="[activecourse[0].baseYear, { active: active_el == 2 }]"
            @click.stop="scrollToTop('equip', 2)"
          >
            <span>E</span>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.navigation.equipping') }}</span>
      </v-tooltip>
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            id="menu-application"
            class="unit-icon mt-3"
            :class="[activecourse[0].baseYear, { active: active_el == 3 }]"
            @click.stop="scrollToTop('application', 3)"
          >
            <span>A</span>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.navigation.accountability') }}</span>
      </v-tooltip>
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            id="menu-mission"
            class="unit-icon mt-3"
            :class="[activecourse[0].baseYear, { active: active_el == 4 }]"
            @click.stop="scrollToTop('mission', 4)"
          >
            <span>M</span>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.navigation.mission') }}</span>
      </v-tooltip>
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            id="menu-supplication"
            class="unit-icon mt-3"
            :class="[activecourse[0].baseYear, { active: active_el == 5 }]"
            @click.stop="scrollToTop('supplication', 5)"
          >
            <span>S</span>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.navigation.supplication') }}</span>
      </v-tooltip>
    </div>

    <!-- Unit Note Menu -->
    <v-navigation-drawer
      v-model="notesOpenUI"
      location="right"
      width="500"
      mobile-breakpoint="0"
      class="custom-drawer"
      :color="isDarkTheme ? '#262626' : ''"
      :class="{ 'top-38': hasNotifications.length }"
      id="unit-notes-drawer"
      :temporary="true"
      :scrim="isMobile ? 'transparent' : false"
    >
      <v-list class="header">
        <v-list-item lines="three">
          <v-list-item-title class="font-weight-bold"
            >{{ $t('unitStudy.notes.title') }}</v-list-item-title
          >
          <v-list-item-subtitle class="font-weight-bold text-red pr-5"
            >{{ $t('unitStudy.notes.saveWarning') }}</v-list-item-subtitle
          >
        </v-list-item>
      </v-list>

      <CustomQuill
        v-model="unit.unitNotes"
        class="editor-4 mb-0 custom-notes-editor"
        :allow-images="false"
        :placeholder="$t('unitStudy.notes.placeholder')"
      />

      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            class="unit-icon mt-3"
            id="notes-save-button"
            :class="[activecourse[0].baseYear, { active: notesOpenUI }]"
            @click.stop="openNotes(1)"
            >{{ $t('unitStudy.notes.saveButton') }}</v-btn
          >
        </template>
        <span>{{ $t('unitStudy.notes.saveTooltip') }}</span>
      </v-tooltip>
    </v-navigation-drawer>

    <!-- Highlights Drawer (mirrors Notes drawer) -->
    <v-navigation-drawer
      v-model="highlightsOpen"
      location="right"
      width="400"
      elevation="0"
      mobile-breakpoint="0"
      class="custom-drawer"
      :color="isDarkTheme ? '#262626' : ''"
      :class="{ 'top-38': hasNotifications.length }"
      id="unit-highlights-drawer"
      :scrim="isMobile ? 'transparent' : false"
      :temporary="true"
    >
      <HighlightsPanel
        :course-id="$route.params.courseID"
        :unit-id="$route.params.id"
        :section-id="$route.params.sectionID"
      />
    </v-navigation-drawer>

    <!-- Comments Drawer -->
    <v-navigation-drawer
      v-model="commentsOpen"
      location="right"
      width="400"
      elevation="0"
      mobile-breakpoint="0"
      class="custom-drawer"
      :color="isDarkTheme ? '#262626' : ''"
      :class="{ 'top-38': hasNotifications.length }"
      id="unit-comments-drawer"
      :scrim="isMobile ? 'transparent' : false"
      :temporary="true"
    >
      <CommentsPanel
        :course-id="$route.params.courseID"
        :unit-id="$route.params.id"
        :section-id="$route.params.sectionID"
        :activecourse="activecourse"
      />
    </v-navigation-drawer>

    <div class="engagement-tools">
      <v-tooltip
        location="right"
        v-if="
          (getRoles && getRoles.includes('tester')) ||
          (getFeatures && getFeatures.includes('users-notes'))
        "
      >
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            class="unit-icon mt-10 icon-pencil"
            id="menu-unit-notes"
            :class="[activecourse[0].baseYear, { active: notesOpenUI }]"
            @click.stop="openNotes(1)"
          >
            <v-icon size="20">note-edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.notes.drawerLabel') }}</span>
      </v-tooltip>

      <!-- Highlights toggle (near the Notes button) -->
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            id="menu-highlights"
            class="unit-icon mt-3"
            :class="[activecourse[0].baseYear, { active: highlightsOpen }]"
            @click.stop="openHighlights(1)"
          >
            <v-icon size="20">mdi-format-color-highlight</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.highlights.drawerLabel') }}</span>
      </v-tooltip>

      <!-- Comments toggle -->
      <v-tooltip location="right">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            elevation="0"
            id="menu-comments"
            class="unit-icon mt-3"
            :class="[activecourse[0].baseYear, { active: commentsOpen }]"
            @click.stop="openComments(1)"
          >
            <v-icon size="20">mdi-comment-text</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('unitStudy.comments.drawerLabel') }}</span>
      </v-tooltip>
    </div>
  </div>
  <!-- Right-side mobile tabs (only visible on small screens) -->
  <div class="engagement-tabs-mobile d-md-none">
    <v-tooltip location="left">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          class="unit-icon"
          id="tab-notes-mobile"
          :class="[activecourse[0].baseYear, { active: notesOpenUI }]"
          @click.stop="openNotes(1)"
        >
          <v-icon size="20">note-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('unitStudy.notes.drawerLabel') }}</span>
    </v-tooltip>

    <v-tooltip location="left">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          class="unit-icon"
          id="tab-highlights-mobile"
          :class="[activecourse[0].baseYear, { active: highlightsOpen }]"
          @click.stop="openHighlights(1)"
        >
          <v-icon size="20">mdi-format-color-highlight</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('unitStudy.highlights.drawerLabel') }}</span>
    </v-tooltip>

    <v-tooltip location="left">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          class="unit-icon"
          id="tab-comments-mobile"
          :class="[activecourse[0].baseYear, { active: commentsOpen }]"
          @click.stop="openComments(1)"
        >
          <v-icon size="20">mdi-comment-text</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('unitStudy.comments.drawerLabel') }}</span>
    </v-tooltip>
  </div>
  <!-- ./Right-side mobile tabs -->
</template>

<script>
  import db from '@/firebase/init'
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'
  import CustomQuill from '@/components/utilities/CustomQuill.vue'
  import HighlightsPanel from '@/components/highlights/HighlightsPanel.vue'
  import CommentsPanel from '@/components/comments/CommentsPanel.vue'
  import { currentTheme } from '@/plugins/vuetify'
  import emitter from '@/eventBus'

  export default {
    name: 'UnitNavigation',
    props: ['unit', 'unitbackdoor', 'activecourse', 'hasNotifications'],
    components: {
      CustomQuill,
      HighlightsPanel,
      CommentsPanel,
    },
    data() {
      return {
        feedback: null,
        active_el: 0,
        unitNotesContent: '',
      }
    },
    watch: {
      notesOpenUI(v) {
        if (v) {
          this.highlightsOpen = false
          this.commentsOpen = false
          // Ensure feedback drawer closes when notes opens
          emitter.emit('closeFeedbackDrawer')
          if (!this.isMobile) this.attachOutsideListener()
        } else if (!this.isMobile && !this.highlightsOpen && !this.commentsOpen) {
          this.detachOutsideListener()
        }
      },
      highlightsOpen(v) {
        if (v) {
          this.notesOpenUI = false
          this.commentsOpen = false
          if (!this.isMobile) this.attachOutsideListener()
        } else if (!this.isMobile && !this.notesOpenUI && !this.commentsOpen) {
          this.detachOutsideListener()
        }
      },
      commentsOpen(v) {
        if (v) {
          this.highlightsOpen = false
          this.notesOpenUI = false
          if (!this.isMobile) this.attachOutsideListener()
        } else if (!this.isMobile && !this.notesOpenUI && !this.highlightsOpen) {
          this.detachOutsideListener()
        }
      },
    },
    computed: {
      ...mapGetters('AppData', ['getFeatures']),
      ...mapGetters('UserData', ['getRoles']),
      ...mapState('UserData', ['user']),
      isDarkTheme() {
        return currentTheme.value === 'dark'
      },
      isMobile() {
        const dv = this.$vuetify?.display
        return dv ? dv.smAndDown : window.innerWidth <= 767
      },
      notesOpenUI: {
        get() {
          return this.$store.getters['AppData/notesOpen']
        },
        set(v) {
          this.$store.dispatch('AppData/notesOpen', v)
        },
      },
      highlightsOpen: {
        get() {
          return this.$store.getters['AppData/highlightsOpen']
        },
        set(v) {
          this.$store.dispatch('AppData/highlightsOpen', v)
        },
      },
      commentsOpen: {
        get() {
          return this.$store.getters['AppData/commentsOpen']
        },
        set(v) {
          this.$store.dispatch('AppData/commentsOpen', v)
        },
      },
    },
    methods: {
      scrollToTop(id, el) {
        this.active_el = el
        document.getElementById(id).scrollIntoView({ behavior: 'auto' })
      },
      downloadPdfURL() {
        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id

        if (this.user && this.user !== null) {
          let href = '/unitpdf'
          if (
            process.env.NODE_ENV === 'development' ||
            process.env.NODE_ENV === 'true'
          ) {
            href = '/unitpdf'
          }
          href += `/${courseID}/${sectionID}/${unitID}`

          return href
        }

        return
      },
      openNotes() {
        const wasOpen = this.notesOpenUI
        this.highlightsOpen = false
        this.commentsOpen = false
        
        // If opening notes (not closing), close feedback drawer FIRST
        if (!wasOpen) {
          // Emit event to close feedback drawer
          emitter.emit('closeFeedbackDrawer')
          // Also directly update localStorage to prevent it from reopening
          localStorage.setItem('feedback_drawer_open', 'false')
        }
        
        this.notesOpenUI = !wasOpen

        emitter.emit('openNote')

        if (wasOpen) {
          // closing notes -> save
          this.saveNotes()
        }
      },
      closeNotesForFeedback() {
        // Close notes drawer when feedback drawer opens
        this.notesOpenUI = false
      },
      openHighlights() {
        const wasOpen = this.highlightsOpen
        this.notesOpenUI = false
        this.commentsOpen = false
        
        // If opening highlights (not closing), close feedback drawer
        if (!wasOpen) {
          emitter.emit('closeFeedbackDrawer')
          localStorage.setItem('feedback_drawer_open', 'false')
        }
        
        this.highlightsOpen = !wasOpen
      },
      openComments() {
        const wasOpen = this.commentsOpen
        this.highlightsOpen = false
        this.notesOpenUI = false
        
        // If opening comments (not closing), close feedback drawer
        if (!wasOpen) {
          emitter.emit('closeFeedbackDrawer')
          localStorage.setItem('feedback_drawer_open', 'false')
        }
        
        this.commentsOpen = !wasOpen
      },
      saveNotes() {
        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id

        let unitNotes = this.unit.unitNotes

        var coursecontentRef = db.collection('coursecontent')
        coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
        coursecontentRef = coursecontentRef.where('sectionID', '==', sectionID)
        coursecontentRef = coursecontentRef.where('unitID', '==', unitID)
        coursecontentRef = coursecontentRef.where('isNotes', '==', 'yes')

        coursecontentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                // console.log(doc.data())
                if (unitNotes == '') {
                  doc.ref.delete()
                } else {
                  doc.ref.update({
                    unitNotes: unitNotes,
                  })
                }
              })
            } else {
              // console.log("No such document!")
              if (unitNotes) {
                db.collection('coursecontent').add({
                  courseID: courseID,
                  sectionID: sectionID,
                  isNotes: 'yes',
                  unitID: unitID,
                  unitNotes: unitNotes,
                })
              }
            }
          })
          .then(() => {
            // console.log('complete')
          })
          .catch(function (error) {
            console.log('Error getting document:', error)
          })
      },
      notificationsAreOpen() {
        // when notifications drawer opens, close notes
        this.notesOpenUI = false
        this.highlightsOpen = false
      },
      onGlobalPointerDown(e) {
        // ignore any tap from the mobile tab rail
        const mobileTabs = document.querySelector('.engagement-tabs-mobile')
        if (mobileTabs && mobileTabs.contains(e.target)) return

        const drawers = [
          {
            open: this.notesOpenUI,
            close: () => {
              // route through openNotes so unsaved notes still get persisted
              this.openNotes(1)
            },
            el: document.getElementById('unit-notes-drawer'),
            activator:
              document.getElementById('menu-unit-notes') ||
              document.getElementById('tab-notes-mobile'),
          },
          {
            open: this.highlightsOpen,
            close: () => {
              this.highlightsOpen = false
            },
            el: document.getElementById('unit-highlights-drawer'),
            activator:
              document.getElementById('menu-highlights') ||
              document.getElementById('tab-highlights-mobile'),
          },
          {
            open: this.commentsOpen,
            close: () => {
              this.commentsOpen = false
            },
            el: document.getElementById('unit-comments-drawer'),
            activator:
              document.getElementById('menu-comments') ||
              document.getElementById('tab-comments-mobile'),
          },
        ]

        for (const { open, close, el, activator } of drawers) {
          if (!open || !el) continue
          if (el.contains(e.target)) return
          if (
            activator &&
            (activator === e.target || activator.contains(e.target))
          )
            return
          // small defer so we never compete with the tap that just fired
          setTimeout(close, 10)
        }
      },
      attachOutsideListener() {
        // use pointerdown so it works for mouse + touch, and in capture phase
        window.addEventListener('pointerdown', this.onGlobalPointerDown, true)
        // optional: Esc to close
        window.addEventListener('keydown', this.onEsc, true)
      },

      detachOutsideListener() {
        window.removeEventListener(
          'pointerdown',
          this.onGlobalPointerDown,
          true
        )
        window.removeEventListener('keydown', this.onEsc, true)
      },

      onEsc(e) {
        if (e.key === 'Escape') {
          if (this.notesOpenUI) this.openNotes(1)
          if (this.highlightsOpen) this.highlightsOpen = false
          if (this.commentsOpen) this.commentsOpen = false
        }
      },
      onViewportResize() {
        // Collapse any open drawer when we cross the 767/768 CSS breakpoint,
        // so drawer chrome re-renders under the correct media-query rules
        // instead of getting stuck with mobile sizing on desktop or vice versa.
        const wasMobile = this._wasMobileCss
        const nowMobile = window.innerWidth <= 767
        if (wasMobile !== nowMobile) {
          this._wasMobileCss = nowMobile
          if (this.notesOpenUI) this.notesOpenUI = false
          if (this.highlightsOpen) this.highlightsOpen = false
          if (this.commentsOpen) this.commentsOpen = false
        }
      },
    },
    created() {
      // listen for notifications event
      emitter.on('openNotifications', this.notificationsAreOpen)
      // listen for feedback drawer opening event
      emitter.on('closeNotesDrawer', this.closeNotesForFeedback)

      // ensure all three drawers start CLOSED
      this.notesOpenUI = false
      this.highlightsOpen = false
      this.commentsOpen = false
    },
    mounted() {
      this._wasMobileCss = window.innerWidth <= 767
      window.addEventListener('resize', this.onViewportResize)
    },
    beforeUnmount() {
      this.detachOutsideListener()
      window.removeEventListener('resize', this.onViewportResize)
      emitter.off('openNotifications', this.notificationsAreOpen)
      emitter.off('closeNotesDrawer', this.closeNotesForFeedback)
    },
  }
</script>

<style scoped>
  .unit-nav-container {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 90px;
    margin-left: -70px;
  }
  /* the rail is height-capped on desktop; scroll instead of squashing the ribbon */
  .unit-nav-container > * {
    flex-shrink: 0;
  }
  /* hide scrollbar but allow scrolling */
  .unit-nav-container {
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    overflow-y: scroll;
  }

  .unit-nav-container::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  .unit-nav-container.top-38 {
    top: 158px;
  }
  .engagement-tools {
    /* position: fixed; */
    display: flex;
    flex-direction: column;
    align-items: center;
    /* top: 45vh;
    margin-left: -70px; */
  }
  #unit-notes-drawer,
  #unit-highlights-drawer,
  #unit-comments-drawer {
    top: 10% !important;
    height: 75% !important;
    padding: 20px;
  }
  .v-icon {
    font-family: museo-sans, sans-serif;
  }
  .unit-icon {
    background: #383935;
    border-radius: 50%;
    width: 29px;
    height: 29px;
    font-weight: 600;
  }
  .custom-drawer :deep(.v-navigation-drawer__content) {
    display: flex;
    flex-direction: column;
  }
  #notes-save-button {
    border-radius: 6px;
    width: fit-content;
  }
  .unit-icon.v-btn--icon.v-size--default .v-icon {
    width: 11.46px;
    height: 11.46px;
  }
  .icon-pencil:not(.active).blueYear svg :deep(path) {
    fill: #002b45;
  }
  .v-theme--dark .icon-pencil:not(.active).blueYear svg :deep(path) {
    fill: #5b6d81;
  }
  .icon-pencil:not(.active).greenYear svg :deep(path) {
    fill: #024731;
  }
  .v-theme--dark .icon-pencil:not(.active).greenYear svg :deep(path) {
    fill: #5e8372;
  }
  .icon-pencil:not(.active).redYear svg :deep(path) {
    fill: #6e273d;
  }
  .v-theme--dark .icon-pencil:not(.active).redYear svg :deep(path) {
    fill: #a26f7b;
  }
  .icon-pencil.active :deep(path) {
    fill: #fff;
  }
  .unit-icon.blueYear {
    border: 1px solid #002b45;
    background: transparent;
    color: #002b45;
  }
  .v-theme--dark .unit-icon.blueYear {
    border: 1px solid #5b6d81;
    background: transparent;
    color: #5b6d81;
  }
  .unit-icon.greenYear {
    border: 1px solid #024731;
    background: transparent;
    color: #024731;
  }
  .v-theme--dark .unit-icon.greenYear {
    border: 1px solid #5e8372;
    background: transparent;
    color: #5e8372;
  }
  .unit-icon.redYear {
    border: 1px solid #6e273d;
    background: transparent;
    color: #6e273d;
  }
  .engagement-tabs-mobile :deep(.unit-icon) {
    background: #fff;
  }
  .v-theme--dark .unit-icon.redYear {
    border: 1px solid #a26f7b;
    background: transparent;
    color: #a26f7b;
  }
  .unit-icon.blueYear.active {
    background: #002b45;
    color: #fff;
  }
  .unit-icon.greenYear.active {
    background: #024731;
    color: #fff;
  }
  .unit-icon.redYear.active {
    background: #6e273d;
    color: #fff;
  }
  .unit-icon.blueYear:active:before,
  .unit-icon.blueYear:focus:before,
  .unit-icon.greenYear:active:before,
  .unit-icon.greenYear:focus:before,
  .unit-icon.redYear:active:before,
  .unit-icon.redYear:focus:before {
    opacity: 0;
  }
  .team-container {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
  }
  .custom-notes-editor {
    max-height: 75%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .custom-notes-editor :deep(#users-notes-editor) {
    flex: 1;
    margin-bottom: 20px;
  }
  .engagement-tabs-mobile {
    position: fixed;
    top: 45%;
    right: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-right: 6px;
  }
  /* neutralize Vuetify's stacking offset when another right drawer is open */
  #unit-highlights-drawer,
  #unit-comments-drawer {
    right: 0 !important;
  }
  @media only screen and (min-width: 768px) {
    .unit-nav-container {
      height: 60vh;
      overflow: scroll;
      padding-bottom: 10%;
    }
    .engagement-tabs-mobile {
      display: none !important;
    }
  }
  @media only screen and (max-width: 981px) {
    .unit-nav-container {
      margin-left: -60px;
    }
  }
  @media only screen and (max-width: 767px) {
    .unit-nav-container {
      flex-direction: row;
      align-items: center;
      top: 78px;
      margin-left: 0;
      width: 90%;
      /* justify-content: space-evenly;  */
    }
    .engagement-tools {
      display: none !important;
    }
    .unit-nav-container.top-38 {
      top: 116px;
    }
    .team-container {
      flex-direction: row;
      margin-top: 0;
      align-items: baseline;
      justify-content: space-evenly;
      width: 70%;
      margin-left: auto;
      margin-right: auto;
    }
    .unit-nav-container
      :deep(.unit-icon):not(:where(.custom-drawer .unit-icon)) {
      margin-top: 0 !important;
    }
    #unit-notes-drawer,
    #unit-highlights-drawer,
    #unit-comments-drawer {
      height: 75% !important;
      max-width: 92vw !important;
    }
    #unit-notes-drawer.top-38,
    #unit-highlights-drawer.top-38,
    #unit-comments-drawer.top-38 {
      top: 158px !important;
    }
  }
</style>
